import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { CotixLauncherService } from "@featuresAY/cotix/cotix-launcher/cotix-launcher.service";
import { ConnectedPosition, OverlayModule } from "@angular/cdk/overlay";
import { CotixPopupComponent } from "@featuresAY/cotix/cotix-popup/cotix-popup.component";
import { AlertModule, IconModule } from "@jack-sparrow-libraries/ui-kit";
import { animate, style, transition, trigger } from "@angular/animations";
import { LoaderSpinnerAyModule } from "features";

@Component({
	selector: "cba-cotix-launcher",
	imports: [OverlayModule, CotixPopupComponent, IconModule, AlertModule, LoaderSpinnerAyModule],
	templateUrl: "./cotix-launcher.component.html",
	styles: ``,
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: "theme-ay",
	},
	animations: [
		trigger("dropUp", [
			transition(":enter", [
				style({
					opacity: 0,
					transform: "scale(0.3) translateY(20px)",
				}),
				animate(
					"150ms cubic-bezier(0.25, 0.8, 0.25, 1)",
					style({
						opacity: 1,
						transform: "scale(1) translateY(0)",
					}),
				),
			]),
		]),
		trigger("fadeUp", [
			transition(":enter", [
				style({
					opacity: 0,
					width: 0,
				}),
				animate(
					"150ms",
					style({
						opacity: 1,
						width: "inherit",
					}),
				),
			]),
		]),
	],
})
export class CotixLauncherComponent {
	private readonly cotixLauncherService = inject(CotixLauncherService);

	protected readonly $isPopupOpened = this.cotixLauncherService.$isOpen;
	protected readonly $cotixState = this.cotixLauncherService.$cotixState;

	protected readonly cdkConnectedOverlayPositions: ConnectedPosition[] = [
		{
			originX: "end",
			originY: "top",
			overlayX: "end",
			overlayY: "bottom",
			/*
			 * Pour expliquer l'offsetY :
			 * offset : decallage
			 * Y : Vertical
			 * objectif: decaler la popup de son FAB pour pas quelle soit collé a celle ci
			 * -12 car on veut quelle soit decaler de 12px en negatif pour avoir de la place entre la popup et son FAB
			 *
			 * legendes:  FAB= Floating Action Button (Button d'action flotant)
			 * */
			offsetY: -12,
		},
	];

	protected togglePopup() {
		this.cotixLauncherService.togglePopup();
	}

	protected closePopup() {
		this.cotixLauncherService.closePopup();
	}
}
